<template>
  <div class="about">
    <div class="container">
      <h1>This is an about page</h1>
    </div>
  </div>
</template>
